require('./command.js');

(function(){
  PegasusTemplate.MoveRowCommand = PegasusTemplate.Command.extend({
    klass: null,
    backup: null,
    sourceElement: null,
    callback: null,
    parent: null,
    childPosition: null,
    desiredPosition: null,
    descriptionClass: 'moved',
    description: function(){
      return Em.I18n.t('command_descriptions.moved_row');
    }.property(),
    execute: function() {
      var parent = PegasusTemplate.blockRegionInstance,
        element = this.get('klass').create({
          container: parent.container,
          sourceElement: this.get('sourceElement')
        }),
        callback = this.get('callback'),
        child = parent.objectAt( this.get('childPosition') ),
        command = this,
        _super = this._super.bind(this),
        childBlockIsEditing = child.get('blocks').indexOf(
          child.get('blocks').filterProperty('isEdited', true).get('firstObject')
        ),
        isEditingRow = child.get('backgroundImageCell.isEdited');

      parent.removeObject( child );
      parent.insertAt( this.get('desiredPosition'), element );

      if ( callback ) {
        callback(this);
      }

      this._super();

      //Em.run.scheduleOnce( 'afterRender', element, function(){
        //if ( childBlockIsEditing >= 0 ) {
          //PegasusTemplate.lookupController('editing').setProperties({
            //edited: this.get('blocks').objectAt(childBlockIsEditing),
            //content: this.get('blocks').objectAt(childBlockIsEditing).get('payload')
          //});
        //} else if( isEditingRow ) {
          //PegasusTemplate.lookupController('editing').setProperties({
            //edited: this.get('backgroundImageCell'),
            //content: this.get('backgroundImageCell').get('payload')
          //});
        //}
        //this.set('isVisible', true);
        //_super();
      //});
    },

    unexecute: function(callback){
      var parent = PegasusTemplate.blockRegionInstance,
        child = parent.objectAt( this.get('desiredPosition') ),
        reborn = this.get('klass').create({
          container: parent.container,
          sourceElement: this.get('backup')
        }),
        _super = this._super.bind(this);

      parent.removeObject( child );
      parent.insertAt( this.get('childPosition'), reborn );

      Em.run.scheduleOnce( 'afterRender', reborn, function(){
        this.set('isVisible', true);
        _super();
      });
    }
  });
})()
